import { Injectable } from '@angular/core';
import { BaseService, SnackbarData } from '@sb/library/base';
import { SnackbarService } from '@sb/library/snackbar';

@Injectable({
    providedIn: 'root'
})
export class ClipboardManager extends BaseService {

    constructor(private _SnackbarService: SnackbarService) {
        super();
    }

    async Copy(text: string, message?: string) {
        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    'text/html': new Blob([text], { type: 'text/html' }),
                    'text/plain': new Blob([text], { type: 'text/plain' })
                })
            ]);
            this._SnackbarService.CreateBasicSnackBar(new SnackbarData({ Data: message ?? $localize`:@@CommonCopiedToClipboard:Text copied to clipboard` }));
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
    }
}
